export default "__VITE_ASSET__V6Mh4YdM__"